import { useStore } from 'effector-react'

import {
  $instalments,
  $totalCountOfInstalments,
  getInstalmentList,
  instalmentsListMounted,
} from './model'
import { InstalmentRequest } from './types'

export const useInstalmentsList = () => {
  const onChangeInstalmentsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: InstalmentRequest) => {
    instalmentsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const instalments = useStore($instalments)
  const totalCountOfInstalments = useStore($totalCountOfInstalments)
  const loading = useStore(getInstalmentList.pending)
  return {
    instalments,
    totalCountOfInstalments,
    loading,
    onChangeInstalmentsList,
  }
}
